export const HISTORICAL_SUBSCRIPTION_PLAN_SLUGS = [
  'tester-subscription',
  'personalized-subscription-individual',
  'personalized-subscription-professional',
  'basic-subscription',
  'classic-subscription',
  'premium-subscription',
  'elite-subscription',
] as const;

export const CURRENT_SUBSCRIPTION_PLAN_SLUGS = [
  'wetalk',
  'wetalk-plus',
  'wetalk-coach',
  'personalized-subscription',
] as const;

export const ADMIN_LEGACY_FORMULA_OPTIONS = [
  'Abonnement Particulier',
] as const;

export const ORGANIZATION_LIST_PLAN_FILTERS = [
  { id: 'no-subscription', key: 'Sans abonnement' },
  { id: 'personalized-subscription', key: 'Abonnement Particulier' },
  { id: 'wetalk', key: 'We talk Basic' },
  { id: 'wetalk-plus', key: 'We talk Plus' },
  { id: 'wetalk-coach', key: 'We talk Coach' },
] as const;

export function getPlanSlugByDisplayName(name: string): string {
  switch (name) {
    case 'Abonnement Particulier':
      return 'personalized-subscription';
    default:
      return '';
  }
}
